const addProj = () => import(/* webpackChunkName: "herb" */ './addProj');
const indexApp = () => import('./indexAppl.vue');
const indexAdmin = () => import('./indexAdmin');
const brandCorporateEdit = () => import('./brandCorporate.vue');
const brandRegionalEdit = () => import('./brandRegional.vue');
const brandClassicCasesEdit = () => import('./brandClassicCases.vue');

//2023项目储备库管理
export default {
  routes: [
    {
      path: '/brand/v2025/indexApp',
      name: 'brand_v2025_index_App',
      component: indexApp,
      meta: {public: true}
    },
    {
      path: '/brand/v2025/indexAdmin',
      name: 'brand_v2025_index_Admin',
      component: indexAdmin,
      meta: {public: true}
    },
    {
      path: '/brand/v2025/addProj',
      name: 'brand_v2025_add_proj',
      component: addProj,
      meta: {public: true}
    },
    {
      path: '/brand/v2025/brandCorporateEdit',
      name: 'brand_v2025_corporate_edit',
      component: brandCorporateEdit,
      meta: {public: true}
    },
    {
      path: '/brand/v2025/brandRegionalEdit',
      name: 'brand_v2025_regional_edit',
      component: brandRegionalEdit,
      meta: {public: true}
    },
    {
      path: '/brand/v2025/brandClassicCasesEdit',
      name: 'brand_v2025_classic_cases_edit',
      component: brandClassicCasesEdit,
      meta: {public: true}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/brand/V2025/router.js